/**
 * GZConsent
 *
 * Single bridge between Cookiebot's categories and everything downstream: the dataLayer
 * and Shopify's Customer Privacy API (which is what gates the checkout Web Pixel and
 * Shopify-managed pixels).
 *
 * Google Consent Mode is not handled here: GTM owns it, so the page sends neither the
 * defaults nor the updates (ZS-436).
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  /**
   * Returns null until the visitor actually answers the banner: Cookiebot exposes a
   * consent object with everything false beforehand, which is not the same as a refusal.
   */
  function readCookiebotConsent() {
    var cookiebot = window.Cookiebot;
    if (!cookiebot || !cookiebot.consent || !cookiebot.hasResponse) return null;

    return {
      preferences: cookiebot.consent.preferences === true,
      statistics: cookiebot.consent.statistics === true,
      marketing: cookiebot.consent.marketing === true
    };
  }

  // GTM triggers and blocking triggers read the answer from these plain dataLayer
  // variables, independently of the consent state GTM keeps on its own side.
  function pushConsentEvent(consent) {
    window.dataLayer.push({
      event: 'cookie_consent_update',
      consent_preferences: consent.preferences,
      consent_statistics: consent.statistics,
      consent_marketing: consent.marketing
    });
  }

  function shopifyConsentMatches(privacy, consent) {
    if (typeof privacy.currentVisitorConsent !== 'function') return false;
    var current = privacy.currentVisitorConsent() || {};
    return (
      current.analytics === (consent.statistics ? 'yes' : 'no') &&
      current.marketing === (consent.marketing ? 'yes' : 'no') &&
      current.preferences === (consent.preferences ? 'yes' : 'no')
    );
  }

  function syncShopifyConsent(consent) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.setTrackingConsent !== 'function') return;

    // No-op when the Cookiebot Shopify app already recorded the same answer.
    if (shopifyConsentMatches(privacy, consent)) return;

    privacy.setTrackingConsent(
      {
        analytics: consent.statistics,
        marketing: consent.marketing,
        preferences: consent.preferences,
        sale_of_data: consent.marketing
      },
      function () {}
    );
  }

  function withShopifyPrivacyApi(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback();
      return;
    }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) callback();
    });
  }

  var listeners = [];
  var lastSignature = null;

  function apply() {
    var consent = readCookiebotConsent();
    if (!consent) return;

    // Cookiebot can fire several of its events for one answer; only act on real changes.
    var signature = [consent.preferences, consent.statistics, consent.marketing].join('|');
    if (signature === lastSignature) return;
    lastSignature = signature;

    pushConsentEvent(consent);
    withShopifyPrivacyApi(function () {
      syncShopifyConsent(consent);
    });

    window.GZConsent.current = consent;
    listeners.forEach(function (listener) {
      listener(consent);
    });
  }

  window.GZConsent = {
    current: null,
    statisticsAllowed: function () {
      return !!(window.GZConsent.current && window.GZConsent.current.statistics);
    },
    marketingAllowed: function () {
      return !!(window.GZConsent.current && window.GZConsent.current.marketing);
    },
    preferencesAllowed: function () {
      return !!(window.GZConsent.current && window.GZConsent.current.preferences);
    },
    onChange: function (listener) {
      listeners.push(listener);
      if (window.GZConsent.current) listener(window.GZConsent.current);
    }
  };

  window.addEventListener('CookiebotOnConsentReady', apply);
  window.addEventListener('CookiebotOnAccept', apply);
  window.addEventListener('CookiebotOnDecline', apply);

  // Covers the reverse race: Cookiebot already answered before this deferred script ran.
  apply();
})();
